import { SheetModal } from '../../../app/components/SheetModal/SheetModal';
import { SheetModalHeader } from '../../../app/components/SheetModal/SheetModalHeader';
import { useIsMobile } from '../../../app/hooks/useIsMobile';
import { Modal } from '../../../app/components/Modal/Modal';
import SessionIcon from '../../../app/assets/icons/session.svg?react';
import { useThemeContext } from '../../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../Translations/providers/TranslationsContextProvider';
import { Meet } from '../../Meet/domain';
import { useMemo, useState, useEffect } from 'react';

export interface ProfessionalNotAvailableModalProps {
	meet: Meet; 
	onClose: () => void;
}

export function ProfessionalNotAvailableModal({ meet, onClose }: ProfessionalNotAvailableModalProps) {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();
	const isMobile = useIsMobile();
	const [now, setNow] = useState(() => new Date());


	const isMoreThan10MinutesLate = useMemo(() => () => {
		if (!meet?.startDate) return false;
		const meetStartDate = new Date(meet.startDate);
		const diffInMs = now.getTime() - meetStartDate.getTime();
		const diffInMinutes = diffInMs / (1000 * 60);
		return diffInMinutes > 10;
	}, [meet, now]);

	useEffect(() => {
		const interval = setInterval(() => {
			setNow(new Date());
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	const title = useMemo(() => {
		if (isMoreThan10MinutesLate()) {
			return t('waiting_room.professional_no_show.title');
		}
		return t('waiting_room.professional_not_available.title');
	}, [t, isMoreThan10MinutesLate]);

	const message = useMemo(() => {
		if (isMoreThan10MinutesLate()) {
			return t('waiting_room.professional_no_show.message');
		}
		return t('waiting_room.professional_not_available.message');
	}, [t, isMoreThan10MinutesLate]);

	return (
		isMobile ? (
			<SheetModal
				data-testid="waiting-room_professional-not-available"
				isOpen
				header={
					<SheetModalHeader
						prepend={
							<SessionIcon
								fill={theme.colors.brand.primary[300]}
								width={25}
								height={25}
							/>
						}
						title={title}
					/>
				}
				onClose={onClose}
			>
				<p>{message}</p>
			</SheetModal>
		) : (
			<Modal
				data-testid="waiting-room_professional-not-available"
				show
				onClose={onClose}
				title={title}
				$fitToChildren
				prepend={
					<SessionIcon
						fill={theme.colors.brand.primary[300]}
						width={25}
						height={25}
					/>
				}
			>
				<p>{message}</p>
			</Modal>
		)
	);
}
